module.exports = __webpack_public_path__ + "78dd1ffdebe278c2fac5e14c55169d10.svg";